<template>
    <v-app>
        <homepage-nav></homepage-nav>
        <v-content>
            <jumbotron-banner></jumbotron-banner>
            <about-section></about-section>
            <price-list></price-list>
            <!-- <testimony-section></testimony-section> -->
            <faq-section></faq-section>
            <contact-section></contact-section>
        </v-content>
        <!--
        <footer-section></footer-section>
        -->
    </v-app>
</template>

<script>
import api from '@/plugins/api'
import hasLocalToken from '@/tools/hasLocalToken'
import HomepageNav from '@/components/home/HomepageNav'
import JumbotronBanner from '@/components/home/JumbotronBanner'
import AboutSection from '@/components/home/AboutSection'
import PriceList from '@/components/home/PriceList'
// import TestimonySection from '@/components/home/TestimonySection'
import FaqSection from '@/components/home/FaqSection'
import ContactSection from '@/components/home/ContactSection'
// import FooterSection from '@/components/home/FooterSection'

export default {
    components: {
        HomepageNav,
        JumbotronBanner,
        AboutSection,
        PriceList,
        // TestimonySection,
        FaqSection,
        ContactSection,
        // FooterSection,
    },

    beforeRouteEnter(to, from, next) {
        if (hasLocalToken()) {
            next({ name: 'loading' })

            api.get('auth')
                .then(() => {
                    next({ name: 'dashboard' })
                })
                .catch(() => {
                    next(to)
                })
        } else {
            next()
        }
    },

    destroyed() {
        this.$store.commit('home/RESET')
    },
}
</script>
